<!--
 @description view
 @author xiehan
 @date 2018/9/19
-->
<style>

</style>

<template>
  <view-list ref="viewList" :control="tableControl">
    <template slot="header">
      <el-form-item>
        <el-button type="primary" @click="e_config">{{ $t('view.config') }}</el-button>
      </el-form-item>
    </template>
  </view-list>
</template>
<script>
import viewList from '@/views/component/view/viewList'
import ViewBiz from '@/logic/intelligentMonitor/viewBiz'

export default {
  components: {
    viewList
  },
  data () {
    const that = this
    return {
      tableControl: [{
        label: that.$t('common.check'),
        callback: that.e_goDetail
      }, {
        label: that.$t('common.delete'),
        callback: that.e_delete
      }]
    }
  },
  methods: {
    e_config () {
      this.$router.push({ name: 'viewChartSelect' })
    },
    e_goDetail (row, $index, data) {
      const query = {
        viewId: row.id,
        type: row.type
      }
      if (row.extend) {
        query.appName = row.extend.appName
        query.group = row.extend.group
        query.kpiKey = row.extend.kpiKey
        query.dName = row.extend.name
        query.siteCode = row.extend.siteCode
      }
      if (row.param.series && typeof row.param.series === 'string') {
        query.series = row.param.series
      }
      if (row.dataSources && row.dataSources.id) {
        query.dId = row.dataSources.id
        query.dName = row.dataSources.name
      }
      this.$router.push({
        name: 'viewConfig',
        query
      })
    },
    e_delete (row, index, data) {
      this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
        type: 'warning'
      }).then(() => {
        ViewBiz.deleteView({
          id: [row.id]
        }).then((data) => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.$refs['viewList'].search()
        })
      }).catch(() => {

      })
    }
  },
  mounted () {
  }
}
</script>
